import React from "react";
import ButtonOrang from "./ButtonOrang";

export default function HeroContacto({ titulo, buttonText, img, svg }) {
  return (
    <section
      className="relative w-full h-[320px] md:h-[380px] flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(https://api.institucional.global.sidom.io${img})`,
      }}
    >
      {/* Overlay naranja con forma orgánica */}
      <div className="absolute inset-0 rounded-bl-[200px] rounded-tr-[300px] md:rounded-bl-[350px] md:rounded-tr-[500px] z-10">
        <img
          src={`https://api.institucional.global.sidom.io${svg}`}
          alt="Decorative SVG"
          className="absolute top-0 left-0 w-full h-full object-cover opacity-50"
        />
      </div>

      <div className="relative z-20 w-full flex flex-col items-center justify-center px-2">
        <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-extrabold text-center mb-6 drop-shadow-lg">
          {titulo}
        </h2>

        <ButtonOrang text={buttonText} />
      </div>
    </section>
  );
}
